// /programs/script — PT대본 스튜디오.
// 내부 timbox-script 컨테이너를 timbox-api가 /api/v1/scriptstudio/* 로 리버스 프록시한다.
// 같은-오리진 iframe이라(샌드박스 아님) 앱의 자체 /api 호출이 그대로 동작한다.
// 먼저 POST /scriptstudio/_session 으로 로그인 세션 → 접근 쿠키를 받은 뒤 iframe을 띄운다.
import { useEffect, useState } from "react";
import { api } from "../../shared/api/client";

export default function ScriptStudioPage() {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    let alive = true;
    api.post("/scriptstudio/_session")
      .then(() => { if (alive) setReady(true); })
      .catch(() => { if (alive) setError(true); });
    return () => { alive = false; };
  }, []);

  if (error) {
    return (
      <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--text-3)", fontSize: 13, textAlign: "center", padding: 24 }}>
        PT대본 스튜디오에 연결하지 못했습니다.<br />timbox-script 컨테이너가 기동 중인지 확인해 주세요.
      </div>
    );
  }
  if (!ready) {
    return (
      <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--text-3)", fontSize: 13 }}>
        여는 중…
      </div>
    );
  }
  return (
    <iframe
      title="PT대본 스튜디오"
      src="/api/v1/scriptstudio/"
      style={{ display: "block", width: "100%", height: "100%", border: "none", background: "var(--bg)" }}
      allow="clipboard-write"
    />
  );
}
